import { useState, useEffect } from "react";
import api from "../../services/api";

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalNuevo, setModalNuevo] = useState(false);
  const [modalResetPass, setModalResetPass] = useState(null);
  const [nuevaClave, setNuevaClave] = useState("");

  const [locales, setLocales] = useState([]);
  const [form, setForm] = useState({
    nombre: "",
    email: "",
    password: "",
    rol: "vendedora",
    local: "",
  });

  useEffect(() => {
    cargar();
    cargarLocales();
  }, []);

  const cargarLocales = async () => {
    try {
      const res = await api.get("/locales");
      setLocales(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await api.get("/usuarios");
      setUsuarios(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const crearUsuario = async () => {
    if (!form.nombre || !form.email || !form.password) {
      alert("Completa nombre, email y contraseña");
      return;
    }
    try {
      await api.post("/usuarios", form);
      setModalNuevo(false);
      setForm({ nombre: "", email: "", password: "", rol: "vendedora", local: "" });
      cargar();
    } catch (err) {
      console.error(err);
      alert("Error al crear usuario: " + (err.response?.data?.message || "revisa los datos"));
    }
  };

  const toggleUsuario = async (id) => {
    try {
      await api.patch(`/usuarios/${id}/toggle`);
      cargar();
    } catch (err) {
      console.error(err);
      alert("Error al cambiar estado");
    }
  };

  const eliminarUsuario = async (id) => {
    if (!window.confirm("¿Eliminar este usuario? Esta accion no se puede deshacer.")) return;
    try {
      await api.delete(`/usuarios/${id}`);
      cargar();
    } catch (err) {
      console.error(err);
      alert("Error al eliminar usuario");
    }
  };

  const resetPassword = async () => {
    if (!nuevaClave || nuevaClave.length < 6) {
      alert("La contraseña debe tener al menos 6 caracteres");
      return;
    }
    try {
      await api.patch(`/usuarios/${modalResetPass.id}/password`, { password: nuevaClave });
      setModalResetPass(null);
      setNuevaClave("");
      alert("Contraseña actualizada correctamente");
    } catch (err) {
      console.error(err);
      alert("Error al resetear contraseña");
    }
  };

  const inputClass = "w-full mt-1 bg-[#E4E9F2] border border-[#E5E9F0] rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#1A56DB] focus:ring-1 focus:ring-[#1A56DB]";
  const labelClass = "text-xs text-gray-500 uppercase tracking-wider font-medium";

  if (loading) {
    return <div className="text-center text-gray-400 py-12 text-sm">Cargando usuarios...</div>;
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm text-gray-500">Gestiona las cuentas de tus vendedoras y producción</p>
        <button
          onClick={() => setModalNuevo(true)}
          className="bg-gradient-to-r from-[#0F1F4D] to-[#1A56DB] text-white text-sm font-medium px-4 py-2 rounded-lg shadow-sm"
        >
          + Agregar usuario
        </button>
      </div>

      <div className="bg-white border border-[#E5E9F0] rounded-xl overflow-x-auto shadow-sm">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-xs text-gray-400 uppercase border-b border-[#E5E9F0]">
              <th className="text-left px-4 py-2">Nombre</th>
              <th className="text-left px-4 py-2">Email</th>
              <th className="text-left px-4 py-2">Rol</th>
              <th className="text-left px-4 py-2">Local</th>
              <th className="text-left px-4 py-2">Estado</th>
              <th className="text-right px-4 py-2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.map((u) => (
              <tr key={u.id} className="border-b border-[#E5E9F0]">
                <td className="px-4 py-3 font-medium text-gray-900">{u.nombre}</td>
                <td className="px-4 py-3 text-gray-500">{u.email}</td>
                <td className="px-4 py-3 capitalize">{u.rol}</td>
                <td className="px-4 py-3 capitalize">{u.local || "—"}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium border ${
                    u.activo ? "bg-green-50 text-green-700 border-green-200" : "bg-red-50 text-red-600 border-red-200"
                  }`}>
                    {u.activo ? "Activo" : "Bloqueado"}
                  </span>
                </td>
                <td className="px-4 py-3 text-right space-x-2">
                  <button onClick={() => setModalResetPass(u)} className="text-[#1A56DB] text-xs font-medium hover:underline">
                    Resetear clave
                  </button>
                  <button
                    onClick={() => toggleUsuario(u.id)}
                    className={`text-xs font-medium px-3 py-1.5 rounded-lg ${
                      u.activo ? "bg-red-50 text-red-600 hover:bg-red-100" : "bg-green-50 text-green-700 hover:bg-green-100"
                    }`}
                  >
                    {u.activo ? "Bloquear" : "Activar"}
                  </button>
                  <button onClick={() => eliminarUsuario(u.id)} className="text-red-600 text-xs font-medium hover:underline">
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
            {usuarios.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center text-gray-400 py-8">No hay usuarios cargados</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {modalNuevo && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center backdrop-blur-sm p-4">
          <div className="bg-white border border-[#E5E9F0] rounded-2xl p-6 w-full max-w-sm shadow-xl">
            <h3 className="text-gray-900 font-semibold text-lg mb-4">Nuevo usuario</h3>
            <div className="space-y-3 mb-4">
              <div>
                <label className={labelClass}>Nombre</label>
                <input type="text" value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} className={inputClass} placeholder="Ej: Vendedora Centro" />
              </div>
              <div>
                <label className={labelClass}>Email</label>
                <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputClass} placeholder="ej: centro@bancher.cl" />
              </div>
              <div>
                <label className={labelClass}>Contraseña</label>
                <input type="text" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputClass} placeholder="Mínimo 6 caracteres" />
              </div>
              <div>
                <label className={labelClass}>Rol</label>
                <select value={form.rol} onChange={(e) => setForm({ ...form, rol: e.target.value })} className={inputClass}>
                  <option value="vendedora">Vendedora</option>
                  <option value="produccion">Producción</option>
                </select>
              </div>
              {form.rol === "vendedora" && (
                <div>
                  <label className={labelClass}>Local</label>
                  <select value={form.local} onChange={(e) => setForm({ ...form, local: e.target.value })} className={inputClass}>
                    <option value="">Selecciona un local...</option>
                    {locales.map((l) => (
                      <option key={l.id} value={l.nombre.toLowerCase()}>{l.nombre}</option>
                    ))}
                  </select>
                </div>
              )}
            </div>
            <div className="flex gap-2">
              <button onClick={crearUsuario} className="flex-1 bg-gradient-to-r from-[#0F1F4D] to-[#1A56DB] text-white font-semibold py-2.5 rounded-lg">
                Crear
              </button>
              <button onClick={() => setModalNuevo(false)} className="bg-gray-100 text-gray-600 px-4 rounded-lg">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {modalResetPass && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center backdrop-blur-sm p-4">
          <div className="bg-white border border-[#E5E9F0] rounded-2xl p-6 w-full max-w-sm shadow-xl">
            <h3 className="text-gray-900 font-semibold text-lg mb-1">Resetear contraseña</h3>
            <p className="text-gray-400 text-sm mb-4">{modalResetPass.nombre} · {modalResetPass.email}</p>
            <div className="mb-4">
              <label className={labelClass}>Nueva contraseña</label>
              <input type="text" value={nuevaClave} onChange={(e) => setNuevaClave(e.target.value)} placeholder="Mínimo 6 caracteres" className={inputClass} />
            </div>
            <div className="flex gap-2">
              <button onClick={resetPassword} className="flex-1 bg-gradient-to-r from-[#0F1F4D] to-[#1A56DB] text-white font-semibold py-2.5 rounded-lg">
                Guardar
              </button>
              <button onClick={() => { setModalResetPass(null); setNuevaClave(""); }} className="bg-gray-100 text-gray-600 px-4 rounded-lg">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
